import React from "react";
import View from "../../pages/registerTeam";
import imageCompression from "browser-image-compression";
import { Loading } from "../../ui/loader";
import { Box } from "@material-ui/core";

class TeamProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      src: null,
      next: false,
      role: "",
      applicationId: "sq0idp-a-iGium_ObGiAtqyR6JAEw",
      dev_applicationId: "sandbox-sq0idb-U_VYYPFCNjw-BcdXP7IS3g",
      locationId: "LB3TCR0TDYJA0",
      selectedPrice: 0,
      slot_id: null,
      teamPaymentPrice: 0,
    };
  }

  componentDidMount() {
    this.props.getTeamProfile(this.props.match.params.id);
    this.props.getCarValues();
    this.props.getRacingBracket();
  }

  updateTeam = (car_info, team_info) => {
    this.props.updateTeamProfile(
      this.props.match.params.id,
      car_info,
      team_info
    );
  };
  onSendInvitation = (email) => {
    this.props.sendInvitationToTeam(this.props.match.params.id, email);
  };
  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 192,
        useWebWorker: true,
      };
      this.setState({ name: event.target.value.split(/(\\|\/)/g).pop() });
      imageCompression(event.target.files[0], options).then(
        (compressedFile) => {
          let reader = new FileReader();
          reader.onload = (e) => {
            this.setState({ src: reader.result });
          };
          reader.readAsDataURL(compressedFile);
        }
      );
    } else {
      this.setState({ src: "", name: "" });
    }
  };
  deleteMember = (id) => {
    this.props.deleteMember(id, this.props.match.params.id);
  };
  deleteUserFromSlot = (id) => {
    this.props.deleteMemberFromSlot(id, this.props.match.params.id);
  };
  approveMember = (id, slot) => {
    this.props.approveMember(id, slot, this.props.match.params.id);
  };

  onRoleChange = (e) => {
    const member_role = e.target.textContent;
    const id = e.target.id;
    this.setState({ role: member_role });
    this.approveMember(id, member_role);
  };
  payForSlot = (nonce) => {
    this.props.payForTeamSlot(
      this.state.slot_id,
      nonce,
      this.props.match.params.id
    );
  };

  payForSlots = (driver_count, crew_count, nonce) => {
    this.props.payForTeamSlots(
      this.props.match.params.id,
      driver_count,
      crew_count,
      nonce
    );
  };
  saveLicenseForSlot = (id, licence, date) => {
    this.props.addLicenseForSlot(id, licence, this.props.match.params.id, date);
  };
  cardNonceResponseReceived = (token, isMultiPayment) => {
    if (token?.errors) {
      this.setState({
        errorMessages: token?.errors.map((error) => error.message),
      });
      alert("Payment failed, enter valid data");
      return;
    }
    if (isMultiPayment) {
      this.setState({ errorMessages: [], teamPaymentPrice: 0 });
      this.payForSlots(token.drivers, token.crews, token.token);
    } else {
      this.setState({ errorMessages: [], selectedPrice: 0 });
      this.payForSlot(token.token);
    }
  };

  onPayClick = (i) => {
    let price = i.price;
    let id = i.id;
    this.setState({ selectedPrice: price / 100, slot_id: id });
  };

  onTeamPaymentButtonClick = (data) => {
    this.setState({ teamPaymentPrice: data?.price });
  };

  onCancelClick = (i) => {
    this.setState({ selectedPrice: 0, teamPaymentPrice: 0 });
  };
  onAssignPayment = (from_slot_id, to_slot_id) => {
    this.props.assignPayment(
      from_slot_id,
      to_slot_id,
      this.props.match.params.id
    );
  };
  onLeaveTeam = () => {
    this.props
      .leaveTeam(this.props.match.params.id)
      .then(this.props.history.push("/teams"));
  };
  onEventDetailsPush = (id) => {
    debugger;
    this.props.history.push(`/events/${id}`);
  };
  onGetInvoice = (id) => {
    this.props.getInvoice(id, this.props.match.params.id);
  };
  onUpdateLicense = (license, userId) => {
    this.props.updateUserProfile(null,null,null,null,null,null,null,null,null,null,null,null,null,null,license, userId,this.props.match.params.id);
}
  render() {
    const { team, carValues, racingBracket } = this.props;
    const id = this.props.match.params.id;
    const { src, applicationId, locationId, selectedPrice, teamPaymentPrice } =
      this.state;
    if (team.loading) {
      return <Loading loading={team.loading} />;
    }
    return (
      <>
        <Box
          border="1px solid #dcdcdc"
          className="rightMemberAreaScreen"
          id="teamProfileContainer"
        >
          <View
            image={src}
            handleUpdateTeam={this.updateTeam}
            handleImageChange={this.onImageChange}
            handleSendInvitation={this.onSendInvitation}
            handleDeleteMember={this.deleteMember}
            handleApproveMember={this.approveMember}
            handleDeleteUserFromSlot={this.deleteUserFromSlot}
            handleRoleChange={this.onRoleChange}
            team={team.team}
            carValues={carValues.carValues}
            teamId={id}
            racingBracket={racingBracket.racingBracket}
            selectedPrice={selectedPrice}
            teamPaymentPrice={teamPaymentPrice}
            applicationId={applicationId}
            locationId={locationId}
            cardNonceResponseReceived={this.cardNonceResponseReceived}
            handleCancelClick={this.onCancelClick}
            handlePayClick={this.onPayClick}
            handleTeamPaymentClick={this.onTeamPaymentButtonClick}
            handleSaveLicenseForSlot={this.saveLicenseForSlot}
            handleAssignPayment={this.onAssignPayment}
            handleLeaveTeam={this.onLeaveTeam}
            handleGetInvoice={this.onGetInvoice}
            handleEventDetailsPush={this.onEventDetailsPush}
            handleDriverLicenseUpdate = {this.onUpdateLicense}
          />
        </Box>
      </>
    );
  }
}

export default TeamProfile;
